import { EmissionsRoute } from "#src/routes/emissions";
import { RoutePath } from "#src/utils/route";

/**
 * route config for /app/emissions/custom-reports
 */
export const EmissionsCustomReportListRoute = EmissionsRoute.concat(
  new RoutePath({
    path: "/custom-reports",
    title: "Emissions Custom Report",
  })
);

export * from "./EmissionsCustomReportListPage";
